class MirabellaReadMore extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const button = this.querySelector('button[aria-controls]');
    if (!button) return;

    this.dataset.collapsed = 'true';
    button.hidden = false;
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      this.dataset.collapsed = String(!expanded);
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('mirabella-read-more')) {
  customElements.define('mirabella-read-more', MirabellaReadMore);
}
